import { FC } from 'react';
import { Content } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import styles from './styles.module.scss';

type Props = {
  slice: Content.SwitcherChartSlice;
  activeTab: number;
};

export const Title: FC<Props> = ({ slice, activeTab }) => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        <PrismicRichText field={slice.primary.title} />
        <span className={styles.categoryType}>
          <span
            className={
              activeTab === 0
                ? styles.categoryTypeFirstActive
                : styles.categoryTypeFirst
            }
          >
            credit score
          </span>
          <span
            className={
              activeTab === 1
                ? styles.categoryTypeSecondActive
                : styles.categoryTypeSecond
            }
          >
            income range
          </span>
        </span>
      </h2>
    </div>
  );
};
